var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairLogo2020White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.23 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,16.51H19.5V30.44H59.56V47H19.5V75H0V0H43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.55,62H58.7L54.22,75H33.43L62,0H83.26l28.55,75H91ZM81.38,47.15l-8.76-25-8.75,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.23,75H174l-18.6-28.84V75h-19.5V0H166.2a29.71,29.71,0,0,1,10.94,1.84,20.68,20.68,0,0,1,12.29,12.38,25.87,25.87,0,0,1,1.54,9q0,8.55-4.13,13.87t-12.18,7.21ZM155.36,33.52H159c3.84,0,6.8-.79,8.85-2.39A8.15,8.15,0,0,0,171,24.27a8.15,8.15,0,0,0-3.09-6.86c-2-1.59-5-2.39-8.85-2.39h-3.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "107.48 0 107.48 37.89 121.61 75 126.98 75 126.98 0 107.48 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairLogo2020White);
export default __webpack_public_path__ + "static/media/FAIRLogo2020-white.ca634593d77e633b326894677f9a8a25.svg";
export { ForwardRef as ReactComponent };